export default {
  stoneConfigurated: false,
};
